import { createContext, useContext, type FC } from "react";

type MenuItems = {
    menuItem: string;
    navEndPoint: string;
}

const MenuProviderContext = createContext<MenuItems[] | undefined>(undefined);

type MenuProviderProps = {
    children : React.ReactNode
}
const MenuProvider:FC<MenuProviderProps> = ({
    children
}: MenuProviderProps) => {
    const menu:MenuItems[] = [
        {menuItem:"JSON FORMATTER", navEndPoint:"/json-formatter"},
        {menuItem:"HTML/XML FORMATTER", navEndPoint:"/html-xml-formatter"},
        { menuItem:"BASE64 ENC / DEC", navEndPoint:"/base64-encoder-decoder"},
        {menuItem:"JWT DECODER", navEndPoint:"/jwt-decoder"},
        {menuItem:"UUID GENERATOR", navEndPoint:"/uuid-generator"},
        {menuItem:"CRON GENERATOR", navEndPoint:"/cron-generator"},
        {menuItem:"TEXT DIFF / COMPARE", navEndPoint:"/text-diff"},
        {menuItem:"WORD COUNTER", navEndPoint:"/word-counter"},
        // {menuItem:"REGEX TESTER", navEndPoint:"/regex-tester"},
        // {menuItem:"TIME FORMATTER", navEndPoint:""},
        // {menuItem:"CSV TO JSON", navEndPoint:""},
        // {menuItem:"LOREM LPSUM", navEndPoint:""},
    ]
    return (
        <MenuProviderContext.Provider value={menu}>
            {children}
        </MenuProviderContext.Provider>
    );
}

export const useMenuProviderContext = () => {
    const context = useContext(MenuProviderContext)
    if(context === undefined){
        throw new Error("Menu provider context is empty");
    }
    return context;
}
export default MenuProvider;